module.exports = __webpack_public_path__ + "static/media/qTritonsInfo1.36694956.webp";